/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
import "./src/css/index.css"

const LOADER_SRC = "https://widget-static.eversports.io/loader.js"
let reinitCount = 0

/**
 * Re-run the Eversports loader so it renders into the placeholders on the
 * current page.
 *
 * The loader (loader.js) is a one-shot module: on execution it does a single
 * `querySelectorAll('[data-eversports-widget-id]')` and renders into whatever
 * it finds. It has NO re-scan API, NO MutationObserver, and is not a custom
 * element — and an ES module only executes once per URL. So after a client-side
 * route change (where React mounts brand-new, empty placeholder divs) the
 * widget stays blank until a full reload.
 *
 * To re-render we re-execute the module with a cache-busting query string
 * (a new URL => the module runs again => it re-scans the DOM). We also:
 *   - clear any already-rendered widget DOM first, so re-running doesn't stack
 *     a second render into the same placeholder (the loader appends a fresh
 *     child node each run), and
 *   - remove the previously injected re-init script to avoid piling up tags.
 *
 * Note: this re-fetches loader.js on each navigation to a widget page (its
 * lazy-loaded chunks stay cached). Acceptable for this site; revisit if
 * Eversports ships a loader with a MutationObserver or an explicit re-scan API.
 */
function reloadEversportsWidgets() {
  if (typeof document === "undefined") return

  const placeholders = document.querySelectorAll("[data-eversports-widget-id]")
  if (!placeholders.length) return

  placeholders.forEach((el) => {
    el.innerHTML = ""
  })

  document
    .querySelectorAll("script[data-eversports-reinit]")
    .forEach((s) => s.remove())

  const script = document.createElement("script")
  script.type = "module"
  script.async = true
  script.setAttribute("data-eversports-reinit", "")
  script.src = `${LOADER_SRC}?reinit=${++reinitCount}`
  document.head.appendChild(script)
}

/**
 * Fires on every route change. We only act on client-side navigations
 * (prevLocation is null on the initial page load, which the loader injected in
 * gatsby-ssr.js already handles). The timeout lets React commit the new route's
 * placeholder divs before we scan for them.
 */
export const onRouteUpdate = ({ prevLocation }) => {
  if (!prevLocation) return
  setTimeout(reloadEversportsWidgets, 50)
}
